import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import FloatingInventory from './main';
import FloatingSummaryScreen from './summary';
import FloatingInventoryAudit from './floatingInventoryAudit';
import FloatingReport from './reports';


export const floatingInventoryRoutes = [
  {
    'component': <FloatingSummaryScreen />,
    'path': paths.FloatingInventorySummary,
  },
  {
    'component': <FloatingInventory />,
    'path': paths.FloatingInventory,
  },
  {
    'component': <FloatingInventoryAudit />,
    'path': paths.FloatingInventoryAudit,
  },
  {
    'component': <FloatingReport />,
    'path': paths.FloatingInventoryReport,
  },
];
